module.exports = __webpack_public_path__ + "img/138ne.df5ee983.svg";